module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_test_tube.7094ad52.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_test_tube.json
// module id = 2233
// module chunks = 0